import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm';
import Pergunta from './Pergunta';

@Entity()
export class Resposta {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  descricao!: string;

  @Column({ type: 'decimal', precision: 5, scale: 2, default: 0 })
  preco!: number;

  @Column()
  maximoItens: number = 1;

  @ManyToOne(() => Pergunta)
  pergunta!: Pergunta;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Resposta;
